<template>
  <v-container>
    <v-row
      align="start"
      justify="start"
    >
      <v-col v-if="!$smallScreen" xs="12" md="6">
        <transition name="fade">
          <div class="pl-2" v-if="configType === 'config'">
            <v-card flat>
              <Configs />
            </v-card>
          </div>
        </transition>
        <transition name="fade">
          <div class="pl-2" v-if="configType === 'theme'">
            <v-card flat>
              <ThemeConfigs />
            </v-card>
          </div>
        </transition>
        <transition name="fade">
          <div class="pl-2" v-if="configType === 'css'">
            <v-card flat>
             <CssCustomization />
            </v-card>
          </div>
        </transition>
      </v-col>

      <v-col :class="{ 'cashier-small-screen' : $smallScreen }" xs="12" sm="12" md="6">
        <div v-if="$smallScreen">
          <v-row>
            <v-col cols="12">
              <v-btn
                @click="renderConfigsSmall = !renderConfigsSmall"
                class="theme-main-color"
                style="margin-bottom:-50px;margin-top:-10px"
                block
                rounded
                variant="outlined">
                Configurations
                <v-icon>{{ !renderConfigsSmall ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <transition name="fade">
                <div v-if="renderConfigsSmall">
                  <Configs />
                </div>
              </transition>
            </v-col>
            <v-col cols="12">
               <Cashier />
            </v-col>
          </v-row>
        </div>
        <Cashier v-if="!$smallScreen" />
      </v-col>

    </v-row>

    <transition name="fade">
      <div v-show="showArrowUp" class="arrow-up">
        <v-btn @click="scrollToTop" color="red" class="box-shadow-up" icon size="x-large">
          <v-icon class="text-white">mdi-arrow-up-bold</v-icon>
        </v-btn>
      </div>
    </transition>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex'
import Cashier from '../components/Cashier'
import Configs from '../components/Configs'
import ThemeConfigs from '../components/ThemeConfigs'
import CssCustomization from '../components/CssCustomization'

export default {
  name: 'CashierCustomization',
  components: {
    Cashier,
    Configs,
    ThemeConfigs,
    CssCustomization
  },
  data: () => ({
    renderConfigsSmall: false,
    showArrowUp: false
  }),
  methods: {
    ...mapMutations([
      'configTypeMutation'
    ]),
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll () {
      if (window.scrollY > 700) {
        this.showArrowUp = true
      } else {
        this.showArrowUp = false
      }
    }
  },
  computed: {
    ...mapState({
      configType: ({ config }) => config.configType
    })
  },
  mounted () {
    this.configTypeMutation('config')
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
#cashier-preview {
  height: 85vh;
  border-radius: 15px;
}
.cashier-small-screen {
  display: flex;
  justify-content: center;
}
.arrow-up {
  position: fixed;
  bottom: 16px;
  right: 16px;
  .box-shadow-up {
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  }
}
</style>
